import { z } from 'zod';
import { ArgoConnectionKindEnum } from '../db';

export const connectionTerminatorSchema = z.union([ z.literal('none'), z.literal('null') ]);
export type ConnectionTerminator = z.infer<typeof connectionTerminatorSchema>;

export const openProtocolConnectionConfigSchema = z.object({
    kind: z.literal(ArgoConnectionKindEnum.OpenProtocol),
    details: z.object({
        ip: z.string(),
        port: z.number(),
        terminator: connectionTerminatorSchema,
    }),
});
export type OpenProtocolConnectionConfig = z.infer<typeof openProtocolConnectionConfigSchema>;
